import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { transitionConfig } from '../models';
import { EditTransitionComponent } from '../../edit-transition/edit-transition.component';
import { Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'irembogov-workflow-transition',
  templateUrl: './transition.component.html',
  styleUrls: ['./transition.component.scss'],
})
export class WorkflowTransitionComponent {
  @Input()
  config!: transitionConfig;

  @Output() updateTransition = new EventEmitter<any>();

  @ViewChild('endStateOne') endStateOne!: ElementRef;

  @ViewChild('endStateTwo') endStateTwo!: ElementRef;

  constructor(public el: ElementRef, private modalService: NgbModal) {}

  onEdit(config: any) {
    this.modalService.dismissAll();

    const modalRef = this.modalService.open(EditTransitionComponent, {
      centered: true,

      windowClass: 'state-workflow-editor-modal',
    });
    modalRef.componentInstance.workflowCode = config;
    modalRef.result.then(result => {
      if (result !== 'delete') {
        this.updateTransition.emit({ result, config });
      }
      if (result === 'delete') {
        this.updateTransition.emit({ result, config });
      }
    });
  }
}
